import { useMutation } from "@apollo/client";
import { schema } from "./schema";
import { gqlQueryStringBuilder } from "utils";
import { IChangePasswordRequest, IChangePasswordResponse, ILoginRequest, ILoginResponse, ILoginResponseBluePrint, IResetPasswordRequest, IResetPasswordResponse, ISendOTPRequest, ISendOTPResponse, ISignUpRequest, ISignUpResponse, IVerifyOTPRequest, IVerifyOTPResponse, loginResponseBluePrint } from "./types";

export const useAuthService = () => {
    const [changePassword] = useMutation<{changePassword: IChangePasswordResponse}, IChangePasswordRequest>(schema.changePassword(
        gqlQueryStringBuilder<IChangePasswordResponse>(
            ["success"]
        )
    ));
    const [resetPassword] = useMutation<{resetPassword: IResetPasswordResponse}, Partial<IResetPasswordRequest>>(schema.resetPassword(
        gqlQueryStringBuilder<IResetPasswordResponse>(
            ["success"]
        )
    ));
    const [verifyToken] = useMutation<{verifyToken: IVerifyOTPResponse}, Partial<IVerifyOTPRequest>>(schema.verifyToken(
        gqlQueryStringBuilder<IVerifyOTPResponse>(
            ["otpVerifiedToken"]
        )
    ));
    const [sendOTP] = useMutation<{sendOTP: ISendOTPResponse}, Partial<ISendOTPRequest>>(schema.sendOTP(
        gqlQueryStringBuilder<ISendOTPResponse>(
            ["otp", "success"]
        )
    ));
    const [signUp] = useMutation<{signUp: ISignUpResponse}, ISignUpRequest>(schema.signUp(
        gqlQueryStringBuilder<ISignUpResponse, ILoginResponseBluePrint>(
            ["accessToken", "userId", "user"], loginResponseBluePrint
        )
    ))
    const [login] = useMutation<{login: ILoginResponse}, ILoginRequest>(schema.login(
        gqlQueryStringBuilder<ILoginResponse, ILoginResponseBluePrint>(
            ["accessToken", "userId", "user"], loginResponseBluePrint
        )
    ))

    return {
        login,
        signUp,
        sendOTP,
        verifyToken,
        resetPassword,
        changePassword
    }
}